/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { loadingPayoutListConfig } from '../../config/loading.config';

export interface ILoadingPayoutListListPluginMethods extends IPluginMethodMap {
  getLoadingPayoutListListSync(args?: any): any;
}

export class LoadingPayoutListListPlugin implements IAgentPlugin {
  readonly methods: ILoadingPayoutListListPluginMethods;

  constructor() {
    this.methods = {
      getLoadingPayoutListListSync:
        this.getLoadingPayoutListListSync.bind(this),
    };
  }

  getLoadingPayoutListListSync(args?: any) {
    return {
      loading: loadingPayoutListConfig,
    };
  }
}
